<div>
    <p>
        {{
            'default-cm-re-attempt-confirmation-message'
                | translate: 'Are you sure you want to re-attempt these selected item?'
        }}
    </p>
    <div class="flex justify-content-end py-2 gap-2">
        <p-button
            class="px-3"
            label="{{ 'default-cm-cancel' | translate: 'Cancel' }}"
            (click)="close()"
            [text]="true"
        ></p-button>
        <p-button (onClick)="reAttempt()" label="{{ 'default-cm-re-attempt' | translate: 'Re-attempt' }}"></p-button>
    </div>
</div>
